


















































import useTemplates from "@/composables/v3/useTemplates";
import useUpload from "@/composables/v3/useUpload";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { isChatAssignedToMeV21, shouldAssignV21 } from "@/utils/chats";
import { defineComponent, watch, computed } from "@vue/composition-api";
import { BDropdown, BDropdownItemButton, BFormFile, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: { BDropdownItemButton, BFormFile, BDropdown },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();

        //----------------------------------------------------------------------

        const { open, getAllowedFileTypes } = useUpload();
        const { activeTabIndex, selectedTemplate, activeChatTemplatesTab } = useTemplates();

        const isActiveChatChannelAvailable = computed(() => {
            return !!channelsStore.activeChatChannel;
        });

        const allowedFileTypes = computed(() => {
            if (!isActiveChatChannelAvailable.value) {
                return "";
            }
            return getAllowedFileTypes(selectedTemplate.value.mediaType, {
                platform: channelsStore.activeChatChannel.platform.toLowerCase(),
                provider: channelsStore.activeChatChannel.provider.toLowerCase(),
            }).join(",");
        });

        return {
            activeTabIndex,
            activeChatTemplatesTab,
            open: () => open({ accept: allowedFileTypes.value }),
            chatsStore,
            channelsStore,
            isChatAssignedToMeV21,
            shouldAssignV21,
            isActiveChatChannelAvailable,
        };
    },
});
